import { html, css } from "@umbraco-cms/backoffice/external/lit";
import { appendStyles, interceptLitElement } from "../utils/lit";
import { hookPrototypeFunction } from "../utils/hooks";

// Inject the 'Generate content' button into the content edit view tab, for AI-generated content creation. This will
// only actually be shown when creating a new document, if it's in the list of doc types for which this is enabled

interceptLitElement("umb-content-workspace-view-edit-tab", constructor => {
    // Remove extra top margin from the first <uui-box> that follows this <generate-content-button>,
    // since this button is hidden in most cases, so shouldn't cause extra margin
    appendStyles(constructor, css`
            generate-content-button + uui-box {
                margin-top: 0 !important;
            }
        `);

    hookPrototypeFunction(constructor, "render", next => {
        return html`
            <generate-content-button></generate-content-button>

            ${next()}
        `;
    });

    return constructor;
});
